import { sepolia } from "viem/chains";

export const SUPPORTED_NETWORK = [sepolia];

export const tierRanges = {
  explorer: { min: 1000, max: 10000, display: '1,000+ AQLX' },
  connector: { min: 10000, max: 50000, display: '10,000+ AQLX' },
  champion: { min: 50000, max: 250000, display: '50,000+ AQLX' },
  visionary: { min: 250000, max: 1000000, display: '250,000+ AQLX' },
  legend: { min: 1000000, max: Infinity, display: '1,000,000+ AQLX' }
};
